"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiAlertStyles = void 0;
exports.muiAlertStyles = {
    defaultProps: {
        severity: 'error',
        variant: 'outlined',
    },
    /*
     * styleOverrides: {
     *   root: {
     *     backgroundColor: parseRSPToken('rsp.comp.alert.container.color'),
     *     boxShadow: parseRSPToken('rsp.comp.alert.container.elevation'),
     *     borderRadius: parseRSPToken('rsp.comp.alert.container.shape'),
     *     borderColor: parseRSPToken('rsp.comp.alert.container.outline-color'),
     *     borderWidth: parseRSPToken('rsp.comp.alert.container.outline-width'),
     *     padding: parseRSPToken('rsp.comp.alert.container.padding'),
     */
    /*
     *     '& .MuiAlert-message': {
     *       padding: 0,
     *     },
     */
    /*
     *     '& .RSPAlert-space': {
     *       height: parseRSPToken('rsp.comp.alert.text-container.padding-bt-element'),
     *     },
     */
    /*
     *     '& .RSPAlert-description': {
     *       color: parseRSPToken('rsp.comp.alert.description-text.color'),
     *       fontFamily: parseRSPToken('rsp.comp.alert.description-text.font'),
     *       fontWeight: parseRSPToken('rsp.comp.alert.description-text.weight'),
     *       fontSize: parseRSPToken('rsp.comp.alert.description-text.size'),
     *       letterSpacing: parseRSPToken('rsp.comp.alert.description-text.letter-spacing'),
     *       lineHeight: parseRSPToken('rsp.comp.alert.description-text.line-height'),
     *     },
     */
    /*
     *     '& .MuiAlert-icon': {
     *       padding: 0,
     *     },
     */
    /*
     *     '& .MuiAlert-action': {
     *       padding: 0,
     */
    /*
     *       '& .MuiButtonBase-root': {
     *         marginLeft: parseRSPToken('rsp.comp.alert.container.padding-bt-element'),
     *         marginRight: '8px',
     *       },
     *     },
     *   },
     */
    /*
     *   icon: {
     *     marginRight: parseRSPToken('rsp.comp.alert.container.padding-bt-element'),
     */
    /*
     *     '& .MuiSvgIcon-root': {
     *       color: parseRSPToken('rsp.comp.alert.type-icon.color'),
     *       fontSize: parseRSPToken('rsp.comp.alert.type-icon.size'),
     *     },
     *   },
     */
    /*
     *   outlinedWarning: {
     *     borderColor: parseRSPToken('rsp.comp.alert.warning.container.outline-color'),
     */
    /*
     *     '& .MuiAlert-icon': {
     *       '& .MuiSvgIcon-root': {
     *         color: parseRSPToken('rsp.comp.alert.warning.type-icon.color'),
     *       },
     *     },
     *   },
     */
    /*
     *   outlinedSuccess: {
     *     borderColor: parseRSPToken('rsp.comp.alert.success.container.outline-color'),
     */
    /*
     *     '& .MuiAlert-icon': {
     *       '& .MuiSvgIcon-root': {
     *         color: parseRSPToken('rsp.comp.alert.success.type-icon.color'),
     *       },
     *     },
     *   },
     * },
     */
};
//# sourceMappingURL=alert.js.map